import React from 'react';
import {Box, Pagination} from '@mui/material'

const DefaultPaginator = ({page, npagine, cambiaPagina}) => {

    return (
        <Box  display={"flex"} flexDirection={"row-reverse"}>
            {/* Pagina corrente {page} / {npagine}                                         */}
            <Pagination 
                count={npagine} 
                page={page} 
                variant={"outlined"} 
                shape={"rounded"} 
                size="small"
                onChange={cambiaPagina} 
            />                                                
        </Box>
    )
}

export default DefaultPaginator;